import Icon from '../components/Icon.vue'

Icon.register({
  'globe-asia': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM236.7 248.2C233.8 253.1 228.6 256 222.9 256H222.6C218.4 256 214.3 257.7 211.3 260.7L205.7 266.4C202.5 269.5 202.5 274.5 205.7 277.7L211.3 283.3C214.3 286.3 216 290.4 216 294.6V304C216 312.8 208.8 320 200 320H193.9C187.8 320 182.3 316.6 179.6 311.1L157 265.9C154.5 261 148 260 144.2 263.8L124.7 283.3C121.7 286.3 117.6 288 113.4 288H50.8C49.1 277.6 48 266.9 48 256 48 145.7 137.7 56 248 56 269.5 56 290.2 59.5 309.6 65.8L259.5 104.4C254.4 107.8 254.8 115.4 260.3 118.2L271.2 123.6C276.6 126.3 280 131.8 280 137.9V216C280 220.4 276.4 224 272 224H268.9C265.9 224 263.1 222.3 261.8 219.6 260.2 216.5 255.8 216.3 254 219.3L236.7 248.2zM408 358.4C408 362.7 406.3 366.7 403.3 369.7L393.7 379.3C390.7 382.3 386.7 384 382.4 384H367.3C363 384 359 382.3 356 379.3L342.9 366.3A26.8-26.8 0 0 1 317.5 359.3L296.3 364.6C295 364.9 293.7 365.1 292.4 365.1H282C277.8 365.1 273.7 363.4 270.7 360.4L258.8 348.5A8-8 0 0 0 256.5 342.8V332.6C256.5 329.3 258.5 326.4 261.5 325.2L300.9 309.4C302.8 308.6 304.7 307.6 306.4 306.4L330.1 289.5A8-8 0 0 0 334.8 288H346.9C350.1 288 353 289.9 354.3 292.9L359.6 305.8A4-4 0 0 1 363.3 308.2H367.1C368.9 308.2 370.5 307.1 370.9 305.4L375.1 290.9C375.6 289.2 377.2 288 379 288H385C387.3 288 389 289.8 389 292V304.9C389 307.1 389.9 309.1 391.4 310.6L403.3 322.5C406.3 325.5 408 329.6 408 333.8V358.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/globe-asia.js
// module id = xIH3
// module chunks = 144